
//favorites
export const FAVORITES = 'FAVORITES';